<template>
    <tr class="stage__row">
        <StageName
            :stage="stage"
            @update="stageName => updateStage(stage.getId(), 'name', stageName)"
            @delete="$emit('delete', stage.getId())"
        />
        <StageRelated
            :stages="stages"
            :stage="stage"
            @update="stageRelated => updateStage(stage.getId(), 'relatedStageId', stageRelated)"
        />
        <StageResponsible
            :responsibleUserId="stage.responsible"
            @update="stageResponsible => updateStage(stage.getId(), 'responsible', stageResponsible)"
        />
        <StageDuration
            :stage="stage"
            @update="stageDuration => updateStage(stage.getId(), 'duration', stageDuration)"
        />
    </tr>
</template>

<script>
import StageName from "@/vue/plan/input/StageName";
import StageRelated from "@/vue/plan/input/StageRelated";
import StageResponsible from "@/vue/plan/input/StageResponsible";
import StageDuration from "@/vue/plan/input/StageDuration";
import PlanStageNewModel from "@/vue/plan/model/PlanStageNewModel";

export default {
    name: "TaskNewStage",
    components: {StageDuration, StageResponsible, StageRelated, StageName},
    props: {
        stages: {
            type: Array,
        },
        stage: {
            validator: (stage) => PlanStageNewModel === stage.constructor,
        },
    },
    methods: {
        updateStage(stageId, prop, value) {
            this.$emit('update', {stageId, prop, value});
        },
    }
}
</script>
